// =============================================================
// 双产品数据模型（航富通 / 航富通 Nova）
// 定位：覆盖审美驱动的新零售行业（文创/饰品/潮玩/谷子/服装/珠宝/美妆/手作/杂货）
//       Nova 是旗舰版，优势在性能体验、操作便捷、更快迭代与更多新功能。
// =============================================================

export const PRODUCT_TYPES = {
  STD: 'standard',
  NOVA: 'nova',
}

export const PRODUCT_NAMES = {
  [PRODUCT_TYPES.STD]: '航富通',
  [PRODUCT_TYPES.NOVA]: '航富通 Nova',
}

// 目标行业（新零售/审美零售）
export const industries = [
  { name: '文创', tag: '文创好物', color: '#A855F7' },
  { name: '饰品', tag: '潮流饰品', color: '#EC4899' },
  { name: '潮玩', tag: '潮流玩具', color: '#F59E0B' },
  { name: '谷子', tag: '二次元周边', color: '#22D3EE' },
  { name: '服装', tag: '时尚服饰', color: '#60A5FA' },
  { name: '珠宝', tag: '精致珠宝', color: '#F472B6' },
  { name: '美妆', tag: '潮流美妆', color: '#FB923C' },
  { name: '手作', tag: '原创手作', color: '#34D399' },
  { name: '杂货', tag: '创意杂货', color: '#FACC15' },
]

export const products = [
  {
    type: PRODUCT_TYPES.STD,
    name: '航富通',
    tagline: '开单收银 · 进销存 · 会员 · 报表 · 员工管理',
    audience: '审美新零售 · 全行业覆盖',
    targetUser: '文创 / 饰品 / 潮玩 / 谷子 / 服装 / 珠宝 / 美妆 / 手作 / 杂货门店',
    oneLiner: '把好品味做成好生意，让每一家审美门店都数字化经营',
    icon: 'store',
    link: '/product/standard',
    isFlagship: false,
  },
  {
    type: PRODUCT_TYPES.NOVA,
    name: '航富通 Nova',
    tagline: '更快的性能 · 更便捷的操作 · 更快迭代新功能',
    audience: '审美新零售 · 追求更好的体验',
    targetUser: '希望获得更流畅、更高效、更前沿体验的潮流门店',
    oneLiner: '旗舰版 · 为追求更快、更好体验和更快迭代的潮流生意而生',
    icon: 'rocket',
    link: '/product/nova',
    isFlagship: true,
    isNew: true,                 // 新品标识
    launchDate: '2026.08.01',    // 上市时间
    highlight: '全新旗舰 · 更快 / 更省心 / 先人一步',
  },
]



// WEBPACK FOOTER //
// ./src/site/data/products.js